import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable, Subject } from "rxjs";
import { RxFormGroup } from "@rxweb/reactive-form-validators";

@Injectable({
	providedIn: "root",
})
export class MediasService {
	baseUrl = `${environment.apis.base}/medias`;

	constructor(private readonly http: HttpClient) {}

	// medias.service.ts
	datatable(page?: number, options: any = {}): Observable<any> {
		let httpParams = new HttpParams();

		if (typeof page === "number") {
			httpParams = httpParams.append("page", page);
		}

		if ("key" in options && options.key.trim() !== "") {
			httpParams = httpParams.append("search", options.key);
		}

		// Aquí debes agregar esto para enviar los filtros correctamente:
		if ("client_id" in options && options.client_id) {
			httpParams = httpParams.append("client_id", options.client_id);
		}
		if ("category_id" in options && options.category_id) {
			httpParams = httpParams.append("category_id", options.category_id);
		}

		return this.http.get<any>(this.baseUrl, { params: httpParams });
	}

	getMediasByType(type?: string): Promise<any> {
		let url = `${environment.apis.base}/getMediasByType`;

		url += `?type=${type}`;

		return this.http.get<any>(url).toPromise();
	}

	show(id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.get<any>(url);
	}

	showAll(): Promise<{
		current_page: number;
		data: any[];
		total: number;
		per_page: number;
		next_page_url: string | null;
		prev_page_url: string | null;
	}> {
		const url = `${this.baseUrl}`;

		return this.http
			.get<{
				current_page: number;
				data: any[];
				total: number;
				per_page: number;
				next_page_url: string | null;
				prev_page_url: string | null;
			}>(this.baseUrl)
			.toPromise();
	}

	createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
		let url = this.baseUrl;

		if (id) {
			url += `/${id}`;
			// Si estamos actualizando, enviamos JSON plano, NO FormData
			return this.http.put<any>(url, data.getRawValue());
		}

		// Si estamos creando, sí usamos FormData
		return this.http.post<any>(url, data.toFormData());
	}

	delete(id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.delete<any>(url);
	}

	list(filter?: any): Observable<Object> {
		const url = `${this.baseUrl}/list`;

		return this.http.get<any>(url);
	}
}
